export const RESIDUAL_SECTION_NAME = "residualsSection";
export const PROCESSOR_SPONSOR_SECTION_NAME = "processorSponsorSection";
